module.exports = __webpack_public_path__ + "img/peanut.e703c13e.png";